import styled from 'styled-components';

export const Container = styled('div')`
    color: ${(props) => props.theme.colors.cardSettingsTextColor};
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    width: 100%;
    justify-content: space-between;
`;

export const Message = styled.span`
`;
